<header class="py-12 px-16 py-24-768 px-48-768 dashboardHeader border-bottom-rgbaGrey500">
  <div
    class="logo-container d-flex align-items-center justify-content-md-center justify-content-between gap-16-768 relative flex-grow-1">
    <a href="#"><img src="assets/images/idp-ielts-cobrand-rgb.svg" class="idp-logo" alt="IDP logo" /></a>
    <div class="profile">
      <button class="profile-name d-flex align-items-center justify-content-around background-charcoalGrey500 circle"
        (click)="profileDropdown()" (keyup)="profileDropdown()"><span class="heading6 heading6-768 txt-white font-semibold">{{userName?.charAt(0)?.toUpperCase()}}</span></button>
      </div>
    </div>
    @if (showProfileDropdown) {
      <div
        class="profile-dropdown border-rgbaGrey500 flex-column background-white py-16 gap-12 py-20-768 gap-16-768 round-4 round-4-768 shadow-small z-4 d-flex">
        <div class="profile d-flex flex-column gap-16 gap-16-768">
          <button class="d-flex align-items-center gap-8 px-16 px-20-768 gap-8-768" (click)="openProfilePage()" (keyup)="openProfilePage()">
            <img src="assets/images/person-circle-outline.svg" alt="profile" class="profile-hover">
            <span class="font-open paragraph-small paragraph-Medium-768">My profile</span>
          </button>
          <button class="d-flex align-items-center gap-8 px-16 px-20-768 gap-8-768" (click)="openAccountSettings()">
            <img src="assets/images/settings.svg" alt="settings" width="24" height="24" class="profile-hover">
            <span class="font-open paragraph-small paragraph-Medium-768">Account settings</span>
          </button>
        </div>
        <div class="divider background-rgbaGrey500">
        </div>
        <div class="logout">
          <button class="d-flex align-items-center gap-8 px-16 px-20-768 gap-8-768 w-100" (click)="signOut()" (keyup)="signOut()">
            <img src="assets/images/exit-outline.svg" alt="exit" class="profile-hover">
            <span class="font-open paragraph-small paragraph-Medium-768">Log out</span>
          </button>
        </div>
      </div>
    }
  </header>
